import { UFOExperience } from '@atlassian/ufo';
import { isAuthError, isErrorStatusCode, isNetworkError, StatusCode } from '../error';
import { createErrorMetadata, isIgnoredError } from './utils';
export class TeamsUFOExperience extends UFOExperience {
  abortWithError(error, reason) {
    return super.abort({
      metadata: {
        error: createErrorMetadata(error),
        reason
      }
    });
  }
  failWithError(error) {
    if (error instanceof Error) {
      if (isAuthError(error)) {
        return this.abortWithError(error, 'Abort due to user unauthenticated');
      }
      if (isErrorStatusCode(StatusCode.GONE, error)) {
        return this.abortWithError(error, 'Abort due to unavailable resource');
      }
      if (isIgnoredError(error)) {
        return this.abortWithError(error, 'Abort due to an error in ignore list');
      }
      if (isNetworkError(error)) {
        return this.abortWithError(error, 'Abort due to network error');
      }
      return super.failure({
        metadata: {
          error: createErrorMetadata(error),
          packageVersion: "2.23.0",
          packageName: "@atlassian/teams-client"
        }
      });
    }
    return super.failure({
      metadata: {
        error: 'unknown error',
        packageVersion: "2.23.0",
        packageName: "@atlassian/teams-client"
      }
    });
  }
}